module.exports = __webpack_public_path__ + "static/media/IMG_1353.ff0d1a71.JPG";